import axios from "axios";
import { createContext, useContext } from "react";
import { API } from "@/site/common";

const KEY = "es_member";
const getToken = () => localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
export const memberApi = axios.create();
memberApi.interceptors.request.use((c) => { const t = getToken(); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });
export const MEMBER_API = { http: memberApi, base: `${API}/member/listings`, geocode: `${API}/member/geocode`, member: true };
export const saveToken = (t, remember = !sessionStorage.getItem(KEY)) => { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); (remember ? localStorage : sessionStorage).setItem(KEY, t); };
export const clearToken = () => { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); };
export const hasToken = () => !!getToken();
export const TYPES = { bireysel: "Bireysel", kurumsal: "Kurumsal" };

export const MemberCtx = createContext(null);
export const useMember = () => useContext(MemberCtx) || {};

export function googleLogin(type, next) {
  if (type) localStorage.setItem("es_signup_type", type);
  if (next) sessionStorage.setItem("es_next", next);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/hesabim";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export const initials = (n = "") => n.trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toLocaleUpperCase("tr-TR");
export const field = "w-full h-12 rounded-xl border border-slate-200 bg-white px-3.5 text-[15px] text-slate-800 outline-none focus:border-orange-400 focus:ring-4 focus:ring-orange-100 transition-[border-color,box-shadow]";
